import React, { Component } from "react";
import { Row, Col, Container } from "styled-bootstrap-grid";
import styled from "styled-components";
import { updateManagerShift, addManagerShift } from "../../../../../Actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation, Trans } from "react-i18next";
import Toggle from "react-toggle";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import { Inputnumbers } from "../../../../Shared/FormFields";
import TimeInput from "../../../../Shared/TimeInput";
import { GetTimeDateDiff } from "../../../../../Api/Utils/ReuseableFunctions";
class AddShift extends Component {
  constructor(props) {
    super(props);

    let shiftEditData = props.data ? props.data : null;

    this.shiftAllowance = shiftEditData
      ? shiftEditData.shiftAllowance === "Y"
      : false;
    this.state = {
      shiftData: undefined,
      shiftEditData: undefined,
      editMode: true,
      formData: {
        shiftPlan: shiftEditData ? shiftEditData.shiftPlan : "",
        shiftEndTime: shiftEditData ? shiftEditData.shiftEndTime : null,
        shiftStartTime: shiftEditData ? shiftEditData.shiftStartTime : null,
        unPaidBreakTime: shiftEditData
          ? Number(shiftEditData.unPaidBreakTime)
          : Number(0),
        paidBreakTime: shiftEditData
          ? Number(shiftEditData.paidBreakTime)
          : Number(0),
        shiftAllowance: shiftEditData ? shiftEditData.shiftAllowance : false,
        shiftId: shiftEditData ? shiftEditData.shiftId : undefined,
      },
    };
  }

  Save = () => {
    if (this.props.data !== void 0) {
      let payload = Object.assign(this.props.data, this.state.formData);
      payload.shiftAllowance = this.shiftAllowance ? "Y" : "N";
      payload.maintainenceUser = this.props.ssoId;
      this.props.dispatch(updateManagerShift(payload));
    } else {
      let payload = this.state.formData;
      payload.shiftAllowance = this.shiftAllowance ? "Y" : "N";
      payload.maintainenceUser = this.props.ssoId;
      this.props.dispatch(addManagerShift(payload));
    }
    this.props.onClose();
  };
  handleChange = (event) => {
    let formData = this.state.formData;
       formData.unPaidBreakTime = 0;
    if (event.target.name === "unPaidBreakTime") {
      if (this.props.security.enableBreaksCal === "Y" || this.props.security.showMintInt === "Y") {
        formData[event.target.name] = event.target.value;
      } else if (
        event.target.value % 15 === 0 &&
        event.target.value >= 0 &&
        event.target.value < 2440
      ) {
        formData[event.target.name] = event.target.value;
        formData.unPaidBreakTime = Number(formData.unPaidBreakTime);
      } else if (["0122" , "0515" , "0675" , "0635"].includes(this.props.userDefault.branchId)) {
        formData[event.target.name] = event.target.value;
      }
      else {
        formData[event.target.name] = 0;
      }
    } else if (event.target.name === "paidBreakTime") {
      if (event.target.value >= 0 && event.target.value <= 60) {
        formData[event.target.name] = event.target.value;
        formData.paidBreakTime = Number(formData.paidBreakTime);
      }
    } else {
      formData[event.target.name] = event.target.value;
    }
    if (this.props.security.enableBreaksCal === "Y") {
      formData = this.autoBreakCalculation(formData);
    }
    this.setState({ formData });
  };
  autoBreakCalculation = (data) => {
    let actualTimeDiff = GetTimeDateDiff(
      data.shiftStartTime,
      data.shiftEndTime
    ); 
   
    if (actualTimeDiff > 360 && actualTimeDiff <= 540) {
      if (Number(data.unPaidBreakTime) > 30) {
        data.unPaidBreakTime = Number(data.unPaidBreakTime);
      } else {
        data.unPaidBreakTime = 30;
      }

      return data;

    } else if (actualTimeDiff > 540) {
      if (Number(data.unPaidBreakTime) > 45) {
        data.unPaidBreakTime = Number(data.unPaidBreakTime);
      } else {
        data.unPaidBreakTime = 45;
      }
      return data;
    } else {
      return data;
    }
  };
  render() {
    const { t, onClose, security } = this.props;

    const required = value => {
      if (!value.toString().trim().length) {
        return (
          <Div>
            <Trans>required</Trans>
          </Div>
        );
      }
    };
    const StyleTime = {
      fontSize: "15px",
      borderBottom: "1px solid #BABEC3",
      padding: "0px 4px",
      background: "#f1f4f9",
      width: "153px",
    };
    const { formData } = this.state;

    return (
      <MainDiv>
        <ContainerDiv>
          <Form>
            <ContentDiv>
              <Row>
                <Col sm="4">
                  <Span>
                    <Trans>shiftPlan</Trans>
                  </Span>
                  <InputDiv
                    placeholder={t("shiftPlanName")}
                    value={formData.shiftPlan}
                    onChange={this.handleChange}
                    name="shiftPlan"
                    validations={[required]}
                    disabled={formData.shiftId === "1"}
                  />
                </Col>
                <Col sm="4">
                  <SpanDiv>
                    <Trans>startTime</Trans>
                  </SpanDiv>
                  <TimeInputShift
                    showMinInt={security.showMintInt === "Y"}
                    target="shiftStartTime"
                    // breakCal={security.enableBreaksCal === "Y"}
                    time={formData.shiftStartTime}
                    setTime={(data) => {
                      var event = {};
                      event.target = {};
                      event.target.name = "shiftStartTime";
                      event.target.value = data;
                      this.handleChange(event);
                    }}
                    branchId = {this.props.userDefault.branchId}
                    style={StyleTime}
                  />
                </Col>
                <Col sm="4">
                  <SpanDiv>
                    <Trans>endTime</Trans>
                  </SpanDiv>
                  <TimeInputShift
                    target="shiftEndTime"
                    showMinInt={security.showMintInt === "Y"}
                    time={formData.shiftEndTime}
                    setTime={(data) => {
                      var event = {};
                      event.target = {};
                      event.target.name = "shiftEndTime";
                      event.target.value = data;
                      this.handleChange(event);
                    }}
                    branchId = {this.props.userDefault.branchId}
                    // breakCal={security.enableBreaksCal === "Y"}
                    style={StyleTime}
                  />
                </Col>
              </Row>
            </ContentDiv>
            <ContentDiv>
              <Row>
                <Col sm="4">
                  {security.enableBreaksCal === "N" && (
                    <>
                      <SpanDivBox>
                        <Trans>paidBreakTime</Trans>(<Trans>mins</Trans>)
                      </SpanDivBox>
                      <InputDivBlock
                        name="paidBreakTime"
                        value={formData.paidBreakTime}
                        handleChange={this.handleChange}
                        branchId = {this.props.userDefault.branchId}
                      />
                    </>
                  )}
                </Col>
                <Col sm="4">
                  <SpanDivBox>
                    {this.props.security.enableBreaksCal === "Y" ? (
                      <>
                        <Trans>unpaidBreak</Trans>(<Trans>mins</Trans>)
                      </>
                    ) : (
                        <>
                          <Trans>unpaidBreaks</Trans>(<Trans>mins</Trans>)
                      </>
                      )}
                  </SpanDivBox>
                  <InputDivBlock
                    name="unPaidBreakTime"
                    value={formData.unPaidBreakTime}
                    handleChange={this.handleChange}
                    branchId = {this.props.userDefault.branchId}
                  />
                </Col>
                <Col sm="4">
                  <Span>
                    <Trans>shiftAllowance</Trans>
                  </Span>
                  <ToggleButtonDiv>
                    <Togglebutton
                      defaultChecked={this.shiftAllowance}
                      icons={{
                        checked: "Yes",
                        unchecked: "NO",
                      }}
                      onChange={(value) => {
                        this.shiftAllowance = !this.shiftAllowance;
                      }}
                    />
                  </ToggleButtonDiv>
                </Col>
              </Row>
            </ContentDiv>
            <FooterData>
              <BtnCancel onClick={onClose}>
                <Trans>cancel</Trans>
              </BtnCancel>
              <BtnSave disabled={!formData.shiftPlan} onClick={this.Save}>
                <Trans>save</Trans>
              </BtnSave>
            </FooterData>
          </Form>
        </ContainerDiv>
      </MainDiv>
    );
  }
}

const TimeInputShift = styled(TimeInput)`
  border-bottom: 1px solid;
`;
const MainDiv = styled.div`
  font-family: Trebuchet MS;
  background: #f1f4f9;
  border-top: 1px solid #adb5bd;
  color: #4a4a4a;
  width: 103%;
  margin-left: -20px;
`;
const ContainerDiv = styled(Container)`
  width: 70%;
  float: center;
  padding-top: 1%;
`;
const ContentDiv = styled.div`
  font-size: 16px;
  padding-top: 25px;
  text-align: left;
  padding-left: 7%;
`;
const FooterData = styled.div`
  background: #f1f4f9;
  height: 15%;
  padding-top: 22px;
  text-align: center;
  position: fixed;
  right: 0px;
  width: 101%;
  margin-left: 4px;
`;
const BtnSave = styled.button`
  border: 1px solid #95989a;
  width: 130px;
  height: 35px;
  border-radius: 50px;
  margin-right: 10px;
  font-size: 12px;
  color: ${(props) => (props.disabled ? "#666666" : "#ffffff")};
  background: ${(props) => (props.disabled ? "#cccccc" : "#c4151c")};
`;
const BtnCancel = styled.button`
  background: #ffffff;
  border: 1px solid #95989a;
  width: 130px;
  height: 35px;
  border-radius: 50px;
  margin-right: 10px;
  color: #434f5b;
  font-size: 12px;
`;
const InputDiv = styled(Input)`
  position: relative;
  border: none;
  border-bottom: 1px solid #6c757d7a;
  width: 70%;
  outline: none;
  font-size: 16px;
  background: #f1f4f9;
`;
const InputDivBlock = styled(Inputnumbers)`
  position: relative;
  height: "30px",
  overflow-y: "scroll"
  .rc-input-number {
    border-bottom: 1px solid #6c757d7a;
  }
  .rc-input-number-focused {
  border-color:none !important
  box-shadow:none !important
}
  width: 70%;
  outline: none;
  font-size: 16px;
  background: #f1f4f9;
`;
const Span = styled.div`
  //padding-right: 58%;
  font-size: 13px;
`;
const SpanDiv = styled.div`
  font-size: 13px;
`;
const SpanDivBox = styled.div`
  font-size: 13px;
  height: 30px;
`;
const Div = styled.span`
  color: #ff0000;
`;
const ToggleButtonDiv = styled.div`
  padding-top: 7px;
  display: table;
  .react-toggle--checked:hover:not(.react-toggle--disabled)
    .react-toggle-track {
    background-color: #00a6eb;
  }
  .react-toggle:hover:not(.react-toggle--checked) .react-toggle-track {
    background-color: #e0e0e0;
  }
  .react-toggle--checked .react-toggle-track {
    background-color: #00a6eb;
  }
  .react-toggle--checked .react-toggle-track-check {
    opacity: 1 !important;
  }
  .react-toggle--checked .react-toggle-track-x {
    opacity: 0 !important;
  }
  .react-toggle--checked .react-toggle-thumb {
    left: 50px;
    border-color: #00a6eb;
  }
`;
const Togglebutton = styled(Toggle)`
  border-radius: 35px;
  font-size: 14px;
  .react-toggle-track {
    width: 81px;
    height: 34px;
    background-color: #e0e0e0;
  }
  .react-toggle-thumb {
    position: absolute;
    top: 4px;
    left: 5px;
    width: 26px;
    height: 26px;
    border: 1px solid #d9d9d9;
    border-radius: 50%;
    background-color: #fafafa;
    box-sizing: border-box;
    transition: all 0.15s ease;
  }
  .react-toggle-track-x {
    position: absolute;
    width: 10px;
    height: 10px;
    top: 8px;
    right: 25px;
    opacity: 1;
    transition: opacity 0.25s ease;
    color: white;
  }
  .react-toggle-track-check {
    position: absolute;
    width: 14px;
    height: 10px;
    top: 8px;
    left: 14px;
    color: white;
  }
`;

const mapStateToProps = ({
  auth,
  userMessage,
  managerTimesheetData,
  fetchTimesheetSecurity,
}) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    userDefault: auth.user.defaultProfile,
    shiftData: managerTimesheetData.payload.shiftList,
    security: fetchTimesheetSecurity.securityList,
  };
};
export default withRouter(
  connect(mapStateToProps)(withTranslation()(AddShift))
);
